import { NextRouter } from "next/router";
import { ChangeEvent } from "react";

const validateMobile = (e: ChangeEvent<HTMLInputElement>, router: NextRouter) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, "").substring(0, 10);
  const [path, query] = router.asPath.split("?");
  const params = new URLSearchParams(query);
  params.delete("mobile")
  params.append("mobile", e.target.value);
  router.replace(`${path}?${params.toString()}`, undefined, { shallow: true });
}

export const onExtraInfoInputChange = (e: ChangeEvent<HTMLInputElement>, variableName: string, router: NextRouter) => {
  switch (variableName) {
    case "mobile":
    case "leadMobile":
      validateMobile(e, router);
      break;
    default:
      break;
  }
}

export const getMaskedMobile = (num: string | undefined) => {
  if (!num || num.length < 4) return num;
  return "X".repeat(num.length - 4) + num.slice(-4);
};
